import * as actions from "../actions/AuthActions";
import { AuthTokenDecoded } from "../models/auth";
import { AuthState, initialState } from "../store/AuthState";
import buildReducer from "../utils/ReducerBuilder";

export const AuthReducer = buildReducer<AuthState>(initialState)
    .handle(actions.onAuthSuccess, (state, action) => {
        if (action.payload === undefined)
            throw new Error (`Payload cannot be undefined for ${actions.onAuthSuccess.toString()}`);

        const decodedToken = new AuthTokenDecoded(action.payload.accessToken, action.payload.refreshToken);

        return {
            ...state,
            authenticated: true,
            accessToken: action.payload.accessToken,
            refreshToken: action.payload.refreshToken,
            data: decodedToken.tokenData,
        };
    })
    .handle(actions.clientCreds, (state, action) => {
        // console.log(action.type, action.payload, state);

        if (action.payload === undefined)
            return state;

        return {
            ...state,
            clientId: action.payload.clientId,
            clientSecret: action.payload.clientSecret,
        };
    })
    .handle(actions.initialized, (state, action) => {
        return { ...state, initialized: true };
    })
    .handle(actions.onAccessRevoked, (state, action) => {
        // Clear tokens from storage
        console.log("access revoked");

        return {
            ...state,
            accessToken: undefined,
            refreshToken: undefined,
            authenticated: false,
            data: undefined,
            initialized: false,
        };
    })
    .done();



// WEBPACK FOOTER //
// ./src/reducers/AuthReducer.ts